import { theme } from 'antd';

export const useAppTheme = () => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  return { colorBgContainer };
};
